import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

// eslint-disable-next-line react/prefer-stateless-function
export class MetaData extends Component {
  render() {
    const { title, description, image } = this.props;

    return (
      <Helmet>
        {title ? <title>{title}</title> : ''}
        {title ? <meta property="og:title" content={title} /> : ''}
        {description ? (
          <meta property="og:description" content={description} />
        ) : (
          ''
        )}
        {image ? <meta property="og:image" content={image} /> : ''}
      </Helmet>
    );
  }
}

MetaData.displayName = 'MetaData';

MetaData.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string
};

export default MetaData;
